import { Spinner } from '../spinner/index';
import { PageLoaderProps } from './types';

export const PageLoader = ({ loaderText }: PageLoaderProps) => (
  <div className="container-fluid py-5">
    <div className="d-flex justify-content-center align-items-center flex-column position-fixed page-loader">
      <Spinner statusText={loaderText} />
    </div>
  </div>
);
